import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LoginView } from '@es-tools/shared';

const Login: React.FC = () => {
  const navigate = useNavigate();
  const allowDevBypass = import.meta.env.VITE_DEV_BYPASS_AUTH === 'true';

  return (
    <LoginView
      allowDevBypass={allowDevBypass}
      title="Welcome to Easy Street Automation Portal"
      subtitle="The command center for automation across Mars Men, Hollow Socks, and Easy Street Brands"
      logoPrefix="ES"
      logoText="Automation"
      accessDeniedText="Access denied. Please sign in with an approved Easy Street email."
      supportText="Authorized Easy Street Brands employees only"
      brandLinks={[
        { label: 'Easy Street', href: 'https://easystreetbrands.com' },
        { label: 'Mars Men', href: 'https://mengotomars.com' },
        { label: 'Hollow Socks', href: 'https://hollowsocks.com' },
      ]}
      onLoginSuccess={() => navigate('/dashboard')}
    />
  );
};

export default Login;
